import { FaturamentoProduto } from './faturamento-produto.model';

export class FaturamentoAntigo {

  id: number;
  faturamentoProduto: FaturamentoProduto;
  faturamentoBruto: number;
  exportacoes: number;
  vendasZfm: number;
  quantidadeProduzida: number;
  ipi: number;
  pisCofins: number;
  icms: number;
  aquisicoesInformatica: number;
  devolucoes: number;
  incentivoIpi: number;
  incentivoIcms: number;
  faturamentoAcima: boolean;

}
